class HeaderAnimation {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const headerEle = document.querySelector("." + this.el);
    const mm = gsap.matchMedia();
    mm.add('(min-width:769px)', () => {
      gsap.to(headerEle, {
        scrollTrigger: {
          trigger: 'body',
          start: 'top -=10px',
          end: 'top +=300px',
          toggleActions: 'play none reverse none',
          onEnter: () => headerEle.classList.add('is-scroll'),
          onLeaveBack: () => headerEle.classList.remove('is-scroll'),
        }
      })
    })
  }
}
